import { useEffect, useState } from "react";
import { Footer } from "../../components/Footer";
import { FancyButton } from "./components/button";
import { VerticalLine } from "./components/lines";
import { FlexContainer, MainContainer } from "./components/mainContainer";
import { CoverRestaurant } from "./cover";
import { Filosofy } from "./filosofy";
import { FoodGallery } from "./foodGallery";
import { ImgScroll } from "./imgscroll";
import { Location } from "./location";
import { NewsLetter } from "./newsletter";
import { Offerta } from "./offerta";
import { Sponsors } from "./sponsors";
import styled from "styled-components";
import { useTraduzioniQuery } from "../../generated/graphql";
const PrenotaCointainer = styled.div`
  width: 100%;
  padding: 50px 50px;
  box-sizing: border-box;
  @media (max-width: 900px) {
    padding: 50px 0px;
  }
`;
const MenuModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.65);
  z-index: 9999;
`;
const MenuModalCard = styled.div`
  position: relative;
  background: #0f413d;
  color: #d3ceb2;
  border-radius: 28px;
  padding: 32px 28px 28px;
  width: min(94vw, 520px);
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.35);
  text-align: center;
`;
const MenuModalClose = styled.button`
  position: absolute;
  top: 14px;
  right: 14px;
  background: rgba(0, 0, 0, 0.2);
  color: #d3ceb2;
  border: none;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  font-size: 18px;
  cursor: pointer;
`;
const MenuModalLogo = styled.img`
  width: 120px;
  margin: 0 auto 16px;
  display: block;
`;
const MenuModalTitle = styled.h3`
  margin: 0 0 6px;
  font-size: 24px;
  font-weight: 700;
  color: #ff6fb1;
`;
const MenuModalSubtitle = styled.p`
  margin: 0 0 18px;
  font-size: 16px;
  line-height: 1.4;
  color: #b9b39a;
`;
const MenuModalImages = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin: 0 0 22px;

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;
const MenuModalImage = styled.img`
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 16px;
`;
const MenuModalButton = styled.a`
  display: inline-block;
  background: #ff6fb1;
  color: #0f413d;
  font-weight: 700;
  text-decoration: none;
  padding: 12px 28px;
  border-radius: 14px;
  letter-spacing: 0.3px;
  transition:
    transform 0.15s ease,
    box-shadow 0.15s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 26px rgba(0, 0, 0, 0.25);
  }
`;
export function adatta(evt: { data: string }) {
  var offsetH = 0;
  if (false) {
  } else {
    var iFrameID = document.getElementById("iFramePrenota");
    if (iFrameID) {
      iFrameID.style.border = "0";
      iFrameID.style.width = "100%";
      iFrameID.style.marginBottom = "1500px";
      var myHeight = evt.data.toString();
      if (evt.data == "top") {
        var mytop =
          iFrameID.getBoundingClientRect().top +
          window.pageYOffset -
          iFrameID.ownerDocument.documentElement.clientTop -
          offsetH;
        document.documentElement.scrollTop = mytop;
        iFrameID.style.marginBottom = "0";
      } else if (myHeight.substring(0, 6) == "middle") {
        var mytop =
          iFrameID.getBoundingClientRect().top +
          window.pageYOffset -
          iFrameID.ownerDocument.documentElement.clientTop -
          offsetH;
        iFrameID.style.height = window.innerHeight + "px";
        iFrameID.style.marginBottom = "0";
        window.scrollTo(0, mytop);
      } else {
        iFrameID.style.height = evt.data + "px";
        iFrameID.style.marginBottom = "0";
      }
    }
  }
}

const menuAssets = {
  logo: "/menuNatale/logo_kum.png",
  dish1: "/rispic/pizzo.webp",
  dish2: "/rispic/vitello.webp",
};

export function Restaurant() {
  const [isPrenota, setPrenota] = useState<"ristorante" | "bistrot" | boolean>(
    false,
  );
  const [isMenuModalOpen, setMenuModalOpen] = useState(false);
  useEffect(() => {
    if (window.addEventListener) {
      // For standards-compliant web browsers
      window.addEventListener("message", adatta, false);
      return () => window.removeEventListener("message", adatta, false);
    }
  }, []);
  useEffect(() => {
    setMenuModalOpen(false);
  }, []);

  function scrollPrenota() {
    var bookId = document.getElementById("book");
    if (bookId) {
      var mytop =
        bookId.getBoundingClientRect().top -
        120 -
        bookId.ownerDocument.documentElement.clientTop;
      document.documentElement.scrollTop = mytop;
      setPrenota("ristorante");
    }
  }
  const lang = localStorage.getItem("lang") || "it";
  const { data } = useTraduzioniQuery();

  return (
    <>
      {isMenuModalOpen && (
        <MenuModalOverlay>
          <MenuModalCard
            role="dialog"
            aria-modal="true"
            aria-labelledby="menu-modal-title"
            aria-describedby="menu-modal-subtitle">
            <MenuModalClose
              aria-label="Chiudi"
              onClick={() => setMenuModalOpen(false)}></MenuModalClose>
            <MenuModalLogo src={menuAssets.logo} alt="Kùm Restaurant" />
            <MenuModalTitle id="menu-modal-title">
              San Valentine's Dinner
            </MenuModalTitle>
            <MenuModalSubtitle id="menu-modal-subtitle">
              Cena a Lume di Candela <br /> <br /> <br /> <br /> <br />
              <br /> Sabato 14 Febbrario
            </MenuModalSubtitle>
            {/* <MenuModalImages>
              <MenuModalImage src={menuAssets.dish2} alt="Vitello tonnato" />

              <MenuModalImage
                src={menuAssets.dish1}
                alt="Pizzoccheri alla valtellinese"
              />
            </MenuModalImages> */}
            <MenuModalButton
              onClick={() =>
                (window.location.href = "./rispic/san_valentino.pdf")
              }>
              SCOPRI I MENU
            </MenuModalButton>
          </MenuModalCard>
        </MenuModalOverlay>
      )}
      <CoverRestaurant book={scrollPrenota} />
      <FlexContainer>
        <MainContainer>
          <VerticalLine height="70px"></VerticalLine>
          <Filosofy />
          <VerticalLine height="100px" />
          <ImgScroll />
          <Location />
          <Offerta />
          <FancyButton onClick={() => setPrenota("ristorante")} id="book">
            {data?.traduzioniVarie?.prenota}
          </FancyButton>
          <PrenotaCointainer>
            {isPrenota && (
              <iframe
                title="Prenota"
                src={
                  `https://thepadelresort.prenota-web.it/prenotazioni/?iframe=1&lang=${lang}` +
                  (isPrenota === "ristorante" ? "" : "&ristorante=bistrot")
                }
                allowFullScreen
                style={{ border: "none", width: "100%", height: "1000px" }}
                id="iFramePrenota"></iframe>
            )}
          </PrenotaCointainer>
          <FoodGallery />
          <NewsLetter />
        </MainContainer>
      </FlexContainer>
      <Sponsors />
      <Footer
        number="+390318180880"
        email="kumrestaurant@thepadelresort.it"
        prettyNumber="+39 031 8180 880"
      />
    </>
  );
}
